import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsentBanner.css';

const STORAGE_KEY = 'sayagain_cookie_consent';

const CookieConsentBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem(STORAGE_KEY);
        if (!accepted) {
            setVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(STORAGE_KEY, 'true');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner" role="region" aria-label="Cookie consent">
            <p className="cookie-banner-text">
                We use cookies to keep you logged in and improve your experience. We do not use advertising cookies or track you across other sites.{' '}
                <Link to="/legal" className="cookie-banner-link">Learn more</Link>
            </p>
            <button className="cookie-banner-btn" onClick={handleAccept}>
                Got it
            </button>
        </div>
    );
};

export default CookieConsentBanner;
